<mat-toolbar class="titulopartes">Dados profissionais</mat-toolbar>
<div fxLayout="row" fxLayoutGap="20px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>

  <mat-form-field fxFlexOffset="20px" fxFlex="30%">
    <input matInput [(ngModel)]="familiar.pessoasFisica.profissao" maxlength="100" name="profissao"
      placeholder="Profissao">
  </mat-form-field>

  <mat-form-field fxFlex="30%">
    <input matInput [(ngModel)]="familiar.pessoasFisica.nomeEmpresaTrabalho" maxlength="200" name="nomeEmpresaTrabalho"
      placeholder="Nome da Empresa">
  </mat-form-field>

  <div fxLayout="row" fxLayoutGap="20px" fxFlexFill>
    <mat-form-field fxFlex="30%" fxFlexOffset="20px">
      <input matInput [(ngModel)]="familiar.pessoasFisica.telefoneComercial" name="telefoneComercial"
        placeholder="Telefone Comercial" pattern="^(?:\(?([1-9][0-9])\)?\s?)?(?:((?:9\d|[2-9])\d{3})\-?(\d{4}))$"
        [textMask]="{mask: maskPhone}">
    </mat-form-field>
  </div>

</div>